import { t } from "../../i18n";
import { useState } from "react";
import { commitSave, revertToBaseline, useProjectStore } from "../../state/projectStore";
import { finishClose, useUnsavedGuard } from "../../state/unsavedGuard";
import { Dialog } from "../../ui/Dialog";

/**
 * "'<ad>' projesindeki değişiklikler kaydedilsin mi?" — Kaydet / Kaydetme / İptal (AutoCAD'deki gibi).
 * Kaydet: değişiklikleri tut (açık kayıt) · Kaydetme: son kayıt noktasına dön ve onu yaz · ikisinden sonra proje kapanır ve bekleyen eylem çalışır.
 */
export function UnsavedDialog(): JSX.Element | null {
  const { pending, onCancel, clear } = useUnsavedGuard();
  const project = useProjectStore((s) => s.project);
  const [busy, setBusy] = useState(false);
  const [err, setErr] = useState<string>();
  if (!pending || !project) return null;
  const finish = async (run: () => Promise<boolean>): Promise<void> => {
    setBusy(true); setErr(undefined);
    const ok = await run();
    setBusy(false);
    const st = useProjectStore.getState();
    if (!ok) { setErr(st.conflict ? t("Proje sunucuda değişmiş") : st.syncError ?? t("Kaydedilemedi")); return; }
    clear(); finishClose(); pending();
  };
  const cancel = (): void => { setErr(undefined); clear(); onCancel?.(); };
  return (
    <Dialog open onClose={cancel} label={t("Kaydedilmemiş değişiklik")} width={440} tone="warn" footer={<>
      <button type="button" className="cad-btn-primary" disabled={busy} onClick={() => void finish(() => commitSave())}>{busy ? t("Kaydediliyor…") : t("Kaydet")}</button>
      <button type="button" className="cad-btn-box" disabled={busy} onClick={() => void finish(() => revertToBaseline())}>{t("Kaydetme")}</button>
      <button type="button" className="cad-btn-box" disabled={busy} onClick={cancel}>{t("İptal")}</button>
    </>}>
      <h2>“{project.info.name}” {t("projesindeki değişiklikler kaydedilsin mi?")}</h2>
      <p className="text-[11px] text-cad-ink2">{t("Kaydetmezseniz açılıştan ya da son kayıttan bu yana yapılan değişiklikler geri alınır.")}</p>
      {err ? <p role="alert" className="px-2 py-1 bg-cad-badbg text-[#B42318] text-[11px]">{err}</p> : null}
    </Dialog>
  );
}
